import { render, staticRenderFns } from "./goodsunit.vue?vue&type=template&id=2c630fd0&"
import script from "./goodsunit.vue?vue&type=script&lang=js&"
export * from "./goodsunit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports